import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { MilkJson } from '@/types/domain/milk/entities/milkEntity';

import { milkSlice } from '@/domain/milk/redux';
import { service } from '@/share';

export const refreshMilkList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'milk/refreshMilkList',
  async (_, thunkApi) => {
    const result: {
      items: MilkJson[],
      nextToken: string,
    } = await service.milk.getMilkList(null);
    thunkApi.dispatch(milkSlice.actions.setMilkList(result));
  },
);

export const getMilkList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'milk/getMilkList',
  async (_, thunkApi) => {
    const { nextToken, milkList } = thunkApi.getState().milk;
    if (!nextToken) {
      if (milkList.length === 0) {
        thunkApi.dispatch(refreshMilkList());
      }
      return;
    }
    const result: {
      items: MilkJson[],
      nextToken: string,
    } = await service.milk.getMilkList(nextToken);
    const newList = milkList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(milkSlice.actions.setMilkList({
      items: newList,
      nextToken: result.nextToken,
    }));
  },
);

export const createMilk = createAsyncThunk<
  void,
  {
    /** データ */
    data: MilkJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'milk/create',
  async (input, _thunkApi) => {
    await service.milk.createMilk(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.milkNursery.sendNurseryMilk({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);

export const deleteMilk = createAsyncThunk<
  void,
    {
      /** データ */
      data: MilkJson,
      /** 施設IDリスト */
      facilityIds: string[],
    },
  ThunkApiType
>(
  'milk/delete',
  async (input, _thunkApi) => {
    await service.milk.deleteMilk(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.milkNursery.removeNurseryMilk({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);
